
(function() {

  'use strict';

  var num;

  const $LD = {
    loading: document.querySelector('.js-md-Loading'),
    logo: document.querySelector('.js-md-Loading__logo')
  };

  const $Hero = {
    title: document.querySelector('.js-ft-Hero__title'),
    scroll: document.querySelector('.js-ft-Hero__scroll'),
    image: document.querySelector('.js-ft-Hero__image')
  };

  const $Header = document.querySelector('.js-st-Header');

  if (sessionStorage.access_count == 1) {

    // 2回目以降の表示
    $LD.loading.style.display = 'none';

    setTimeout(function(){

      $Hero.image.classList.add('is-show');
      $Hero.title.classList.add('is-show');

      setTimeout(function(){
        $Hero.scroll.classList.add('is-show');
        $Header.classList.add('is-show');
      }, 600);


    }, 300);

	} else {
    // 1回目の表示
    num = 1;
    window.sessionStorage.setItem('access_count', num);

    setTimeout(function(){
      $LD.logo.classList.add('is-show');
    }, 100);

    $LD.logo.addEventListener('transitionend', function(){
      setTimeout(function(){

        $LD.loading.classList.add('is-hide');
        $LD.loading.addEventListener('transitionend', function(){

          $LD.loading.style.display = 'none';
          $Hero.image.classList.add('is-show');

          setTimeout(function(){
            $Hero.title.classList.add('is-show');

            setTimeout(function(){
              $Hero.scroll.classList.add('is-show');
              $Header.classList.add('is-show');
            }, 600);
          }, 300);
        });
      }, 1000);
    });
  }
})();
